import WVFormatter from '../../../../../../shared/helpers/WVFormatter';

export default (props) => {
  const { record } = props;
  const currency = record.params['impactAction.currency'] || 'USD';
  return typeof record.params.deltaAmount !== 'undefined' && record.params.deltaAmount !== null ?
    WVFormatter.formatCurrency(record.params.deltaAmount, currency) : '';
};
